"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var global_options_preview_widget_html_1 = __importDefault(require("./global-options-preview-widget.html"));
(function (module) {
    module.component('prGlobalOptionsPreviewWidget', {
        bindings: {
            decimals: '<',
            colorPalette: '<',
            widgetPadding: '<',
            textFormat: '<',
            metric: '<'
        },
        templateUrl: global_options_preview_widget_html_1.default,
        controller: 'prGlobalOptionsPreviewWidgetController as $pwCtrl'
    });
})(angular.module('qualtrics.pr'));
